import { CommonModule, UpperCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService, TranslatePipe } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideNgxWebstorage, withNgxWebstorageConfig } from 'ngx-webstorage';
import { APP_CONFIG, AppConfig } from './config/app.config';
import { InfoComponent } from './info';
import { UpperCaseDirective } from './directives/uppercase.directive';
import { AlphaNumericDirective } from './directives/alphanumeric.directive';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { Ng2SmartTableModule } from './ui-components/ng2-smart-table';
import { PagerComponent } from './ui-components/pager/pager.component';
import { ErrorBlockComponent } from './modal/error-block/error-block.component';
import {
  PanelNavElementComponent
} from './panel-nav/panel-nav-element/panel-nav-element.component';
import { PanelNavComponent } from './panel-nav/panel-nav.component';
import { SessionDialogComponent } from './session-dialog/session-dialog.component';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpInterceptorService } from './http-interceptor.service';
import { FilterPipe } from './ui-components/pipe/filter.pipe';
import { ShowOfficeInfoComponent } from './show-office-info/show-office-info.component';
import { HttpService } from './http-service';

let checkDevMode = false;

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,

        Ng2SmartTableModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule.forRoot(),
        ModalModule.forRoot(),
        CollapseModule.forRoot(),
        BsDatepickerModule.forRoot(),
        TranslateModule.forRoot({
            loader: provideTranslateHttpLoader({
                prefix: './assets/i18n/',
                suffix: '.json'
            }),
            fallbackLang: 'en'
        })
    ],
    declarations: [
        InfoComponent,
        UpperCaseDirective,
        ErrorBlockComponent,
        PanelNavComponent,
        PanelNavElementComponent,
        SessionDialogComponent,
        PagerComponent,
        AlphaNumericDirective,
        FilterPipe,
        ShowOfficeInfoComponent
    ],
    exports: [
        CommonModule,
        HttpClientModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule,
        ModalModule,
        CollapseModule,
        InfoComponent,
        UpperCaseDirective,
        ErrorBlockComponent,
        Ng2SmartTableModule,
        PanelNavElementComponent,
        PanelNavComponent,
        PagerComponent,
        AlphaNumericDirective,
        FilterPipe,
        ShowOfficeInfoComponent
    ],
    providers: [
        { provide: APP_CONFIG, useValue: AppConfig },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true,
        },
        HttpService,
        provideHttpClient(withInterceptorsFromDi()),
        provideNgxWebstorage(withNgxWebstorageConfig({}))
    ]
})
export class SharedModule {}
